export default __webpack_public_path__ + "static/media/Tomato Seeds.639fd865.PNG";